import { Controller } from "@hotwired/stimulus"
import { Chart } from "frappe-charts"

// Renders a Frappe line chart from data passed via Stimulus values, so the
// same controller drives every chart on the subscription analytics page
// (MRR / ARR / Active subscriptions by month).
export default class extends Controller {
  static values = {
    labels: Array,
    series: Array,
    name: { type: String, default: "" },
    color: { type: String, default: "#16a34a" },
    currency: { type: Boolean, default: false },
  }

  connect() {
    this.chart = new Chart(this.element, {
      type: "line",
      height: 220,
      animate: true,
      colors: [this.colorValue],
      lineOptions: { hideDots: 0, regionFill: 1, spline: 0 },
      axisOptions: { xIsSeries: true },
      data: {
        labels: this.labelsValue,
        datasets: [{ name: this.nameValue, values: this.seriesValue }],
      },
      tooltipOptions: {
        formatTooltipY: (value) => this.format(value),
      },
    })
  }

  disconnect() {
    // Frappe exposes no destroy(); clear the rendered SVG so repeated Turbo
    // visits don't stack duplicate charts in the same container.
    this.element.replaceChildren()
    this.chart = null
  }

  format(value) {
    if (!this.currencyValue) return String(Math.round(value))
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      maximumFractionDigits: 0,
    }).format(value)
  }
}
